const USER_PERMISSIONS = {
  MANUALLY_SETTLE_WINNER_MARKETS: [
    18188, // adam@pandascore.co / svensk
    16780, // serhii@pandascore.co
    10181, // tsvetan@pandascore.co
    17054, // montserrat@pandascore.co
    4100, // karl@pandascore.co
    7826, // clay@pandascore.co
    1194 // cedric@pandascore.co
  ],
  MANUALLY_SETTLE_EBATTLERS_MARKETS: [
    18919, // vladan@pandascore.co
    1194 // cedric@pandascore.co
  ]
};

type UserFeature = keyof typeof USER_PERMISSIONS;

export type { UserFeature };
export { USER_PERMISSIONS };
